<template>
  <div class="content has-text-centered">
    <p>
      <img width="200" src="~assets/samsung.png" :alt="pkg.description">
    </p>

    <div v-if="(isAdmin || isHomenetDev)" class="has-text-left label">Change the below values to reflect in other service pages:</div>
    <Resident
      @partnerChanged="storeResident(RESIDENT_LEVEL.PARTNER)"
      @complexChanged="storeResident(RESIDENT_LEVEL.COMPLEX)"
      @buildingChanged="storeResident(RESIDENT_LEVEL.BUILDING)"
      @houseChanged="storeResident(RESIDENT_LEVEL.HOUSE)"
      @userChanged="storeResident(RESIDENT_LEVEL.USER)"
      :userVisible="userVisible"
      :getServerData="getServerData"
      ref="residentRef">
    </Resident>

    <h1 class="is-title is-bold">{{ pkg.name.replace(/-/gi, ' ') }}</h1>

    <p>
      <strong>{{ pkg.description }}</strong>,
      <a :href="pkg.homepage">Live Demo</a>
    </p>

  </div>
</template>

<script>
import Resident from './homenet/share/Resident'
import myUtil from './homenet/lib/utils'
const RESIDENT_LEVEL = {
  PARTNER: 'partner',
  COMPLEX: 'complex',
  BUILDING: 'building',
  HOUSE: 'house',
  USER: 'user'
}

export default {
  components: {
    Resident
  },

  data () {
    return {
      isAdmin: false,
      isHomenetDev: false,
      pkg: this.$store.state.pkg,
      userVisible: true,
      getServerData: true,
      RESIDENT_LEVEL
    }
  },
  mounted () {
    this.isAdmin = myUtil.isGroupMember(this, 'admin')
    this.isHomenetDev = myUtil.isGroupMember(this, 'homenet-dev')
    if (!this.isAdmin && !this.isHomenetDev) {
      window.addEventListener('auth-token-localstorage-changed', () => {
        this.isHomenetDev = myUtil.isGroupMember(this, 'homenet-dev')
        this.isAdmin = myUtil.isGroupMember(this, 'admin')
      })
    }
  },

  methods: {
    storeResident (residentLevel) {
      let username = ''
      if (this.$auth.watch && this.$auth.watch.data && this.$auth.watch.data.username) {
        username = this.$auth.watch.data.username + '-'
      }
      const resident = this.$refs.residentRef
      if (residentLevel === RESIDENT_LEVEL.PARTNER) {
        console.log('Partner changed')
        window.localStorage.setItem(username + 'partnerList', resident.partnerList)
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner)
      } else if (residentLevel === RESIDENT_LEVEL.COMPLEX) {
        console.log('Complex changed')
        window.localStorage.setItem(username + 'partnerList', resident.partnerList)
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner)
        window.localStorage.setItem(username + 'complexList', resident.complexList)
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex)
      } else if (residentLevel === RESIDENT_LEVEL.BUILDING) {
        console.log('Building changed')
        window.localStorage.setItem(username + 'partnerList', resident.partnerList)
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner)
        window.localStorage.setItem(username + 'complexList', resident.complexList)
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex)
        window.localStorage.setItem(username + 'buildingList', JSON.stringify(resident.buildingList, null, 2))
        window.localStorage.setItem(username + 'selectedBuilding', JSON.stringify(resident.selectedBuilding, null, 2))
      } else if (residentLevel === RESIDENT_LEVEL.HOUSE) {
        console.log('House changed')
        window.localStorage.setItem(username + 'partnerList', resident.partnerList)
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner)
        window.localStorage.setItem(username + 'complexList', resident.complexList)
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex)
        window.localStorage.setItem(username + 'buildingList', JSON.stringify(resident.buildingList, null, 2))
        window.localStorage.setItem(username + 'selectedBuilding', JSON.stringify(resident.selectedBuilding, null, 2))
        window.localStorage.setItem(username + 'houseList', JSON.stringify(resident.houseList, null, 2))
        window.localStorage.setItem(username + 'selectedHouse', JSON.stringify(resident.selectedHouse, null, 2))
      } else if (residentLevel === RESIDENT_LEVEL.USER) {
        console.log('User changed')
        window.localStorage.setItem(username + 'partnerList', resident.partnerList)
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner)
        window.localStorage.setItem(username + 'complexList', resident.complexList)
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex)
        window.localStorage.setItem(username + 'buildingList', JSON.stringify(resident.buildingList, null, 2))
        window.localStorage.setItem(username + 'selectedBuilding', JSON.stringify(resident.selectedBuilding, null, 2))
        window.localStorage.setItem(username + 'houseList', JSON.stringify(resident.houseList, null, 2))
        window.localStorage.setItem(username + 'selectedHouse', JSON.stringify(resident.selectedHouse, null, 2))
        window.localStorage.setItem(username + 'userList', resident.userList)
        window.localStorage.setItem(username + 'selectedUser', resident.selectedUser)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Home.vue?0ce5ded6